import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import { AllInstruments } from '@prlw/core/monitor/all-instruments.entity';
import { AllTableColumn } from '@prlw/core/monitor/types/all-table';
import { Destination } from '@prlw/core/destinations/destination.entity';
import { SyncScrollService } from '@prlw/libs/sync-scroll/sync-scroll.service';
import { Modifier } from '@prlw/core/monitor/types/common';
import { OverflowState } from '@prlw/libs/overflow-fader/overflow-fader.class';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { AllTableColumnContentContainer } from './content/column-content.container';

const GRID_CELL_SIZE = '140px';

@Component({
  selector: 'prlw-all-table-ui',
  templateUrl: './all-table.component.html',
  styleUrls: ['./all-table.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [SyncScrollService],
})
export class AllTableComponent implements AfterViewInit {
  @ViewChild('scroll')
  public scrollRef!: ElementRef;
  @ViewChild('tableContentWrapper')
  public readonly tableContentWrapper!: ElementRef;

  public ngAfterViewInit(): void {
    this.initResizeObserver.emit({
      elemX: this.tableContentWrapper.nativeElement,
      elemY: this.scrollRef.nativeElement,
    });
  }

  @Input() public data: AllInstruments[] | null = null;
  @Input() public columns: AllTableColumn[] | null = null;
  @Input() public modifiers: Modifier | null = null;
  @Input() public destination: Destination | null = null;
  @Input() public overflows: OverflowState | null = null;
  @Output() public readonly sortColumn = new EventEmitter<string>();
  @Output() public readonly updateColumn = new EventEmitter<AllTableColumn[]>();
  @Output() public readonly initResizeObserver = new EventEmitter<{
    elemX: HTMLElement;
    elemY: HTMLElement;
  }>();
  @Output() public readonly setScrollHorizontalPosition =
    new EventEmitter<number>();
  @Output() public readonly setScrollVerticalPosition =
    new EventEmitter<number>();
  public readonly BASIS: AllTableColumn = { name: 'Завод' };
  @Output() private readonly eventOnLoaded = new EventEmitter<void>();

  @ViewChild(AllTableColumnContentContainer)
  set tableRowComponent(c: AllTableColumnContentContainer) {
    if (c) {
      this.eventOnLoaded.emit();
    }
  }

  constructor(private readonly changeDetectorRef: ChangeDetectorRef) {}

  public get gridSize(): string {
    return Array(this.columns?.length).fill(GRID_CELL_SIZE).join(' ');
  }

  public drop(event: CdkDragDrop<AllTableColumn[]>): void {
    if (this.columns) {
      moveItemInArray(this.columns, event.previousIndex, event.currentIndex);
      this.updateColumn.emit(this.columns);
    }
  }

  public sort(columnName: string): void {
    this.sortColumn.emit(columnName);
    this.changeDetectorRef.detectChanges();
  }

  public setHorizontalScroll(event: Event): void {
    const elem = event.target as HTMLElement | null;
    if (elem) {
      this.setScrollHorizontalPosition.emit(elem.scrollLeft);
    }
  }

  public setVerticalScroll(event: Event): void {
    const elem = event.target as HTMLElement | null;
    if (elem) {
      this.setScrollVerticalPosition.emit(elem.scrollTop);
    }
  }
}
